import { gql } from 'apollo-boost';
import { useQuery } from 'react-apollo';
import { removeConnectionsMemoized } from '../';

const query = gql`
  query {
    indicatorStages {
      dbId
      name
    }
  }
`;

export const useIndicatorStages = () => {
  const { data: rawData, refetch, loading } = useQuery(query, { fetchPolicy: 'cache-first' });
  let data = rawData?.indicatorStages ?? [];
  if (data && data.length >= 6) {
    data = [data[5], data[4], data[0], data[1], data[2]];
  }
  return { data, refetch, loading };
};
